import React, { useRef, useEffect } from 'react';
import classnames from 'classnames';
import { matomoEvent } from 'sunzi-utils';
import { W as Wrapper } from './index-9e42f9f8.js';
import { s as styleInject } from './style-inject.es-4a6aca40.js';

var css_248z = "html.sunzi_components__lock-2Z-Fw,\nbody.sunzi_components__lock-2Z-Fw {\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n}\n.sunzi_components__custom-layer-TSeCy {\n  z-index: 1999999998;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.sunzi_components__custom-layer-TSeCy .sunzi_components__content-3DQrM {\n  position: relative;\n  z-index: 2;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  background: #fff;\n  -webkit-animation: sunzi_components__drawer-bottom-3HmCI 0.2s cubic-bezier(0.33, 1, 0.68, 1);\n          animation: sunzi_components__drawer-bottom-3HmCI 0.2s cubic-bezier(0.33, 1, 0.68, 1);\n}\n@-webkit-keyframes sunzi_components__drawer-bottom-3HmCI {\n  from {\n    -webkit-transform: translate(0, 30%);\n            transform: translate(0, 30%);\n    opacity: 0;\n  }\n  to {\n    -webkit-transform: translate(0, 0);\n            transform: translate(0, 0);\n    opacity: 1;\n  }\n}\n@keyframes sunzi_components__drawer-bottom-3HmCI {\n  from {\n    -webkit-transform: translate(0, 30%);\n            transform: translate(0, 30%);\n    opacity: 0;\n  }\n  to {\n    -webkit-transform: translate(0, 0);\n            transform: translate(0, 0);\n    opacity: 1;\n  }\n}\n@media screen and (min-width: 768px) {\n  .sunzi_components__custom-layer-TSeCy .sunzi_components__content-3DQrM {\n    width: 500px;\n    height: 600px;\n    border-radius: 6px;\n    -webkit-box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.1), 0 2px 5px 0 rgba(0, 0, 0, 0.2);\n            box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.1), 0 2px 5px 0 rgba(0, 0, 0, 0.2);\n    -webkit-animation: sunzi_components__bubbles-2AKte 0.2s cubic-bezier(0.33, 1, 0.68, 1);\n            animation: sunzi_components__bubbles-2AKte 0.2s cubic-bezier(0.33, 1, 0.68, 1);\n  }\n  @-webkit-keyframes sunzi_components__bubbles-2AKte {\n    from {\n      -webkit-transform: scale(0.6, 0.6);\n              transform: scale(0.6, 0.6);\n      opacity: 0;\n    }\n    to {\n      -webkit-transform: scale(1, 1);\n              transform: scale(1, 1);\n      opacity: 1;\n    }\n  }\n  @keyframes sunzi_components__bubbles-2AKte {\n    from {\n      -webkit-transform: scale(0.6, 0.6);\n              transform: scale(0.6, 0.6);\n      opacity: 0;\n    }\n    to {\n      -webkit-transform: scale(1, 1);\n              transform: scale(1, 1);\n      opacity: 1;\n    }\n  }\n}\n.sunzi_components__custom-layer-TSeCy .sunzi_components__mask-39jW9 {\n  z-index: 1;\n  background: rgba(0, 0, 0, 0.5);\n  -webkit-animation: sunzi_components__drawer-mask-3Oqoi 0.2s cubic-bezier(0.33, 1, 0.68, 1);\n          animation: sunzi_components__drawer-mask-3Oqoi 0.2s cubic-bezier(0.33, 1, 0.68, 1);\n}\n@-webkit-keyframes sunzi_components__drawer-mask-3Oqoi {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n@keyframes sunzi_components__drawer-mask-3Oqoi {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n";
var styles = {"lock":"sunzi_components__lock-2Z-Fw","customLayer":"sunzi_components__custom-layer-TSeCy","content":"sunzi_components__content-3DQrM","drawerBottom":"sunzi_components__drawer-bottom-3HmCI","bubbles":"sunzi_components__bubbles-2AKte","mask":"sunzi_components__mask-39jW9","drawerMask":"sunzi_components__drawer-mask-3Oqoi"};
styleInject(css_248z);

var CustomLayer = function (_a) {
  var className = _a.className,
      _b = _a.lock,
      lock = _b === void 0 ? true : _b,
      tracker = _a.tracker,
      eventCategory = _a.eventCategory,
      children = _a.children;

  var _html = document.getElementsByTagName('html').item(0);

  var _body = document.getElementsByTagName('body').item(0);

  var _scrollTop = useRef(0);

  var _lock = function (elements) {
    return elements.forEach(function (element) {
      if (element && lock) {
        var _className = element.className;

        if (_className) {
          if (_className.indexOf(styles.lock) === -1) element.className = _className + " " + styles.lock;
        } else element.className = styles.lock;
      }
    });
  };

  var _unlock = function (elements) {
    return elements.forEach(function (element) {
      if (element && lock) element.className = element.className.split(' ').map(function (item) {
        return item.trim();
      }).filter(function (item) {
        return item !== styles.lock;
      }).join(' ');
    });
  };

  useEffect(function () {
    var _a;

    _scrollTop.current = (_a = _html === null || _html === void 0 ? void 0 : _html.scrollTop) !== null && _a !== void 0 ? _a : 0;

    _lock([_html, _body]);

    tracker === null || tracker === void 0 ? void 0 : tracker.trackEvent({
      category: eventCategory,
      action: matomoEvent.tapCustom
    });
    return function () {
      _unlock([_html, _body]);

      _html === null || _html === void 0 ? void 0 : _html.scrollTo(0, _scrollTop.current);
    };
  }, []);
  return React.createElement(Wrapper, {
    position: "fixed",
    className: styles.customLayer
  }, React.createElement("div", {
    className: classnames(styles.content, className)
  }, children), React.createElement(Wrapper, {
    className: styles.mask
  }));
};

export default CustomLayer;
